import React from 'react';
import Logo from '@/assets/images/Logo.svg';

interface LoadingFullProps {
  onComplete?: () => void;
  duration?: number;
}

const LoadingFull: React.FC<LoadingFullProps> = ({
  onComplete,
  duration = 3000
}) => {
  React.useEffect(() => {
    if (onComplete) {
      const timer = setTimeout(() => {
        onComplete();
      }, duration);

      return () => clearTimeout(timer);
    }
  }, [duration, onComplete]);

  return (
    <div className="fixed inset-0 bg-highlight flex flex-col items-center justify-center z-50">
      <div className="flex flex-col items-center space-y-8 max-w-sm w-full px-4">
        <div className="flex items-center justify-center">
          <img
            src={Logo}
            alt="Culture Monitor Logo"
            className="h-12 w-auto"
          />
        </div>
        <p className="text-sm text-muted-foreground">
          Preparando sua experiência...
        </p>
      </div>
    </div>
  );
};

export default LoadingFull; 